import { Modal, ModalBody } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import { withTranslation } from "react-i18next";
import Text from "components/Text";
import styles from "./FailureSuccessRecordsModal.module.scss";
import tooltipImg from "assets/images/info_black-tooltip.svg";
import file_upload_error from "assets/images/file_upload_error.svg";
import file_upload_success from "assets/images/file_upload_success.svg";

import { useState } from "react";

const FailureSuccessRecordsModal = ({ isModalOpen, closeModal, t, data }) => {
  const [showHide, setShowHide] = useState(false);
  const zeroFailed = data?.failedCount === 0;
  return (
    <Modal
      isOpen={isModalOpen}
      toggle={() => closeModal(false)}
      className={"modal-dialog-centered " + styles["modal-main"]}
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={() => closeModal(false)}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
          <span className="modal-title-25">File Upload Status</span>
        </Text>
        <div className={styles.uploadStatusContent}>
          {!zeroFailed && (
            <div className="cbg-warning py-2 px-3 rounded d-flex gap-xxs align-items-center mb-5">
              <img
                src={tooltipImg}
                id="pick-color"
                alt="tooltip"
                width={24}
                height={24}
              />
              <Text size="14px" weight="400" color="#000000">
                {`Some records could not be uploaded because required fields are missing or one or more IDs in the CSV are invalid.
Please check that each record includes Personal Details, Employment Date, Role, Staff Type, Profile Color, and Schedule, then correct any invalid IDs and re-upload the file.`}
              </Text>
            </div>
          )}
          <div
            className={styles.uploadSummary}
            style={{
              border: `2px dashed ${zeroFailed ? "#5FC381" : "#ee4f4f"}`,
              backgroundColor: zeroFailed ? "#FBFEFC" : "#fefbfb",
            }}
          >
            <img
              src={zeroFailed ? file_upload_success : file_upload_error}
              className="mb-3"
              alt="error-icon"
            />
            <h3 className={zeroFailed ? "mb-0" : undefined}>
              {zeroFailed ? "Uploaded Successfully" : "Upload Error"}
            </h3>
            {zeroFailed ? (
              <span className={styles.fileName}>{data?.fileName}</span>
            ) : (
              <>
                <div className={styles.statsRow}>
                  <div className={styles.statItem}>
                    <span className={styles.statLabel}>Total Records</span>
                    <span className={styles.statValue}>
                      {data?.processedCount}
                    </span>
                  </div>
                  <div className={styles.statItem}>
                    <span className={styles.statLabel}>Failed</span>
                    <span className={styles.statValue}>
                      {data?.failedCount}
                    </span>
                  </div>
                  <div className={styles.statItem}>
                    <span className={styles.statLabel}>Success</span>
                    <span className={styles.statValue}>
                      {data?.successCount}
                    </span>
                  </div>
                </div>
                <button
                  className={styles.viewFailedBtn}
                  onClick={() => setShowHide((prev) => !prev)}
                >
                  View Failed Records{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    style={{ rotate: (showHide ? 0 : 180) + "deg" }}
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M13.8449 11.8011L14.1654 11.8011C14.1654 11.9881 14.0961 12.1677 13.971 12.3002C13.7214 12.5638 13.3224 12.5669 13.0689 12.3076L9.99856 9.16338L6.92831 12.3076C6.67512 12.5669 6.27593 12.5638 6.02617 12.3C5.76441 12.023 5.76784 11.567 6.0335 11.2948L9.55148 7.69205C9.80195 7.43595 10.1952 7.43595 10.4458 7.69224L13.9635 11.2947C14.0931 11.4273 14.1654 11.6103 14.1654 11.8011L13.8449 11.8011Z"
                      fill="#587E85"
                    />
                  </svg>
                </button>
              </>
            )}
          </div>
          {showHide && (
            <div className={styles.failedRecordsTable}>
              <table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email Address</th>
                    <th>Phone No.</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.results
                    ?.filter((res) => !res?.isSuccess)
                    ?.map(({ name, mobileNumber, emailId }) => (
                      <tr key={emailId}>
                        <td>{name}</td>
                        <td>{emailId}</td>
                        <td>{mobileNumber}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};
export default withTranslation()(FailureSuccessRecordsModal);
